import { forwardRef, useImperativeHandle, useState } from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import { Column } from "primereact/column";
import MeaStudentRegistrationAvatar from "../../../../components/MeaStudentRegistrationAvatar";
import memberRegistrationsAPI from "../../../../services/member_registrations";
import MeaLink from "../../../../components/MeaLink";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import MeaStudentResult from "../../../../components/MeaStudentResult";
import { useNavigate } from "react-router-dom";
import MeaButton from "../../../../components/MeaButton";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CONTRACTS, PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_REGISTRATION } from "../../../../permissions";

const MemberRegistrationsListComponent = forwardRef((props, ref) => {
    const { member_id, schoolId } = props;
    const accessToken = "";

    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);

    //
    const queryList = memberRegistrationsAPI.useGetList(
        schoolId,
        "",
        accessToken,
        member_id || null,
        page,
        pageSize,
        //JSON.parse(state.studentsFilter)
    );


    //
    useImperativeHandle(ref, () => ({
        refresh: () => {
            queryList?.refetch();
        },
    }));
    return (
        <MeaDataTable query={queryList}
            serviceAPI={memberRegistrationsAPI}
            names={{ pagination: "registrations", singular: "inscription", plural: "inscriptions" }}
            //startToolbarTemplate={startToolbarTemplate}
            //showFilterButton={showFilterButton}
            showToolbar={false}
            setPage={setPage}
            setPageSize={setPageSize}
            rowClassName={(rowData) => {
                if (rowData?.training.status === "OPEN") {
                    return 'bg-green-100';
                } else if (rowData?.training?.status === "DRAFT") {
                    return 'bg-blue-100';
                } else if (rowData?.training?.status === "SUSPENDED") {
                    return 'bg-red-100';
                } else if (rowData?.training?.status === "ARCHIVED") {
                    return 'bg-gray-100';
                } else {
                    return '';
                }
            }}
        >

            <Column header="Inscrit" body={(student) => <MeaStudentRegistrationAvatar student={student} permission={PERMISSION_TRAINING_REGISTRATION.GET} />}></Column>
            <Column header="Formation" body={(student) => {
                return student?.training?.name;
            }}></Column>
            <Column
                field="level"
                header="Niveau"
                body={(student) => (
                    <MeaLink
                        to={
                            "/school/" +
                            student?.school_id +
                            "/admin/trainings/" +
                            student?.training_id +
                            "/levels/" +
                            student?.level_id
                        }
                        permission={PERMISSION_TRAINING_LEVELS.GET}
                    >
                        {student?.level?.name}
                    </MeaLink>
                )}

            ></Column>
            <Column
                field="classe"
                header="Classe"
                body={(student) => (
                    <MeaLink
                        to={
                            "/school/" +
                            student?.school_id +
                            "/admin/trainings/" +
                            student?.training_id +
                            "/classes/" +
                            student?.class_id
                        }
                        permission={PERMISSION_TRAINING_CLASSES.GET}
                    >
                        {student?.classe?.name}
                    </MeaLink>
                )}
            ></Column>

            <Column
                field="status"
                header="Status"
                body={(student) => {
                    return <MeaStudentStatus2 student={student} />;
                }}
            ></Column>
            <Column
                field="result"
                header="Résultat"
                body={(student) => {
                    return <MeaStudentResult student={student} />;
                }}
            ></Column>
            <Column header="Contrat & paiements" body={(item) => {
                return item?.contract_id && <MeaButton permission={PERMISSION_TRAINING_CONTRACTS.GET} icon="pi pi-credit-card" className="p-button-text" onClick={() => {
                    navigate("/school/" + item?.school_id + "/admin/registrations/" + item?.training_id + "/contracts/" + item?.contract_id);
                }} />;
            }} />

        </MeaDataTable>);
});

export default MemberRegistrationsListComponent;